import { styled } from "theme/default/styled";
import { setFlexDF } from "theme/setter/setFlexValues/setFlexDF";

export const SCreateSupportArticleFormHeader = styled.div`
  margin-bottom: 20px;
  gap: 24px;

  ${setFlexDF};
`;
